import { Box } from "@mui/material";
import TkTable from "../../components/atoms/TkTable";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import "./_style.scss";
import { labelids } from "../../assets/data/TkExplanationProperty";
const stepperData = ["内容入力・確認", "加入登録手続き確認", "機構へ提出"];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC060009_01,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "引継ぎコード",
    keyword: "transferCd",
    type: "text",
  },
  {
    title: "施設名",
    keyword: "facilityNameList",
    type: "text",
    requiredIcon: true,
  },

  {
    title: "氏名（ｶﾅ）",
    keyword: "staffNameKana",
    type: "text",
  },
  {
    title: "氏名",
    keyword: "staffNameKanji",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "性別",
    keyword: "sex",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "加入年月日",
    keyword: "joinDate",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "加入資格",
    keyword: "joinCapacity",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "職種",
    keyword: "jobCd",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "俸給表の額",
    keyword: "salaryTableAmt",
    type: "text",
  },
  {
    title: "俸給の調整額",
    keyword: "salaryAdjustmentAmt",
    type: "text",
  },
  {
    title: "被共済職員であったことの有無",
    keyword: "masPastFlg",
    type: "text",
  },
  {
    title: "被共済職員でなくなった理由",
    keyword: "masQuitReason",
    type: "text",
  },
  {
    title: "被共済職員でなくなった年月日",
    keyword: "masQuitDate",
    type: "text",
  },

  {
    title: "前共済契約者名",
    keyword: "bContractName",
    type: "text",
  },
  {
    title: "前共済契約者番号",
    keyword: "bContractNo",
    type: "text",
  },
  {
    title: "前職員番号",
    keyword: "bStaffNo",
    type: "text",
  },
  {
    title: "従業状況",
    keyword: "employee",
    type: "node",
    node: (
      <Box className="table">
        <TkTable headList={[]} bodyList={[]}></TkTable>
      </Box>
    ),
    fullWidth: true,
  },
];

export { stepperData, fakeTableList };
